import type { TagNode } from '@/modules/common/types'
import { TagBadge } from './tag-badge'

interface Props {
  tag: TagNode
  onRemove(): void
}

export const TagChip: React.FC<Props> = ({ tag, onRemove }) => (
  <TagBadge tag={tag} variant="chip" onRemove={onRemove} />
)
